<template>
  <div>
    <card>
      <div slot="header" class='toolsBar'>
        <div class="leftTools" />
        <div>
          <l-button type="info" @click="handlenew()" class='text-right'>新增</l-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column prop="name" label="分類名稱" />
            <el-table-column prop="websiteId" label="網站" />
            <el-table-column label="排序">
              <div slot-scope="props">
                <b class="font-weight-light">{{props.row.sort}}</b>
              </div>
            </el-table-column>
            <el-table-column label="狀態">
              <div slot-scope="props">
                <b>{{getStatusText(props.row)}}</b>
              </div>
            </el-table-column>
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)">
                  <i class="fa fa-edit" />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category" />
        </div>
        <l-pagination class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      @input='handleIndexChange'
                      :total="pagination.total" />
      </div>
    </card>
    <el-dialog
      center
      :title="getTitle()"
      :visible.sync="modals.custom">
      <fg-input label="分類名稱"
                type="text"
                name="name"
                data-vv-as="分類名稱"
                v-model="form.name"
                v-validate="'required'"    
                :error="getError('name')"
                required />

      <div class="form-group align-left">
        <label>網站 *</label>
        <div>
          <el-select class="select-default" data-vv-as="網站" placeholder="請選擇" name="websiteId" v-model="form.websiteId" :error="getError('websiteId')"  v-validate="'required'" >
              <el-option v-for="i in stores" class="select-default" :value="i.id" :label="i.name" :key="i.id" />
          </el-select>
        </div>
        <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('websiteId')">{{ errors.first('websiteId') }}</div>
      </div>

      <fg-input label="排序"
                type="text"
                name="sort"
                data-vv-as="排序"
                v-model="form.sort"
                :error="getError('sort')"
                v-validate="'required|decimal:1'"
                required />
      <div class="form-group align-left">
        <label>狀態</label>
        <div>
          <l-switch v-model="form.status"  on-text="ON" off-text="OFF" />
        </div>
      </div>
      <h2>SEO Setting</h2>
      <hr />
      <fg-input label="Page Alias"
                type="text"
                name="alias"
                data-vv-as="Page Alias"
                v-model="form.alias"
                v-validate="'required'"
                :error="getError('alias')"
                required />
      <fg-input label="Meta 標題"
                type="text"
                name="metaTitle"
                data-vv-as="Meta 標題"
                v-model="form.metaTitle" />
      <fg-input label="Meta 描述"
                type="text"
                name="metaDescription"
                data-vv-as="Meta 描述"
                v-model="form.metaDescription" />
      <fg-input label="Meta 關鍵字"
                type="text"
                name="metaKeywords"
                data-vv-as="Meta 關鍵字"
                v-model="form.metaKeywords" />
      <div class="text-right">
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import LSwitch from 'src/components/Switch.vue'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      LPagination,
      LSwitch
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        form: {
          id: '',
          name: '',
          websiteId: '',
          alias: '',
          sort: 0,
          status: false,
          metaTitle: '',
          metaDescription: '',
          metaKeywords: '',
        },
        searchForm: {
          number:'',
          status:'',
        },
        query: {},
        cuser: null,
        modals: {
          custom: false
        },
        stores: [],
        tableData: []
      }
    },
   async mounted() {
      await this.getStoreData()
      await this.getData()
    },
    watch: {
      'pagination.currentPage': async function(val) {
      }
    },
    computed: {

    },
    methods: {
      getStatusText(row) {
        return (row.status) ? '啟用' : '停用'
      },
      getTitle() {
        return (this.form.id == '')?'新增分類':'編輯分類'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          if (this.form.id === '') {
            _this.createCategory()
          } else {
            _this.updateCategory(this.form)
          }
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.name = row.name,
        this.form.websiteId = row.websiteId,
        this.form.alias = row.alias,
        this.form.sort = row.sort,
        this.form.status = row.status,
        this.form.metaTitle = row.metaTitle,
        this.form.metaDescription = row.metaDescription,
        this.form.metaKeywords = row.metaKeywords
        this.openModal('custom')
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getStoreData() {
        var data = await lib.getStoreList({ offset:0, limit:10 })
        if (data.status == 0) {
          var result = data.result
          this.stores = result.stores
        }
      },

      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.categoryList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.categories
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
            _this.form.id = '',
            _this.form.name = '',
            _this.form.website = '',
            _this.form.alias = '',
            _this.form.sort = 0,
            _this.form.status = true,
            _this.form.metaTitle = '',
            _this.form.metaDescription = '',
            _this.form.metaKeywords = '',
          resolve()
        })
      },
      async createCategory() {
        var data = await lib.createCategory(this.form)
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } else if (data.status == 7) {
           this.$swal('Page Alias重複', '', 'error')
        } else {
          this.$swal('新增失敗', '', 'error')
        }
      },
      async updateCategory() {
        var data = await lib.updateCategory(this.form.id, this.form)
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('已更新', '', 'success')
        } else if (data.status == 7) {
           this.$swal('Page Alias重複', '', 'error')
        } else {
          this.$swal('更新失敗', '', 'error')
        }
      },
      async handleDelete(id, porp) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteItem(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>


<style>
.toolsBar {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}

.leftTools > * {
  padding-right: 10px;
}
</style>
